export default __webpack_public_path__ + "static/media/drive_small.3305f181.png";